import { useMemo } from "react";

type TrendiiProductData = {
  id: string;
  title: string;
  sku?: string;
  price: string;
  currency: string;
};

export const useTrendii = () =>
  useMemo(() => {
    //@ts-ignore
    const trendiiPixel =
      typeof window !== "undefined" && window.__ii ? window.__ii : () => {};

    //@ts-ignore
    const isDev =
      process.env.GATSBY_ACTIVE_ENV === "development" ||
      process.env.NODE_ENV === "development";

    const trackAddToCart = (product: TrendiiProductData, qunatity: number) => {
      if (isDev) console.log(`[TRENDii] add to cart fired.`);

      trendiiPixel.send({
        eventName: "PixelAddToCart",
        eventData: {
          id: product.id,
          quantity: qunatity,
          product: {
            id: product.id,
            title: product.title,
            sku: product.sku,
            price: product.price,
            currency: product.currency,
          },
        },
      });
    };

    const trackPageLoad = (product: TrendiiProductData) => {
      if (isDev) console.log(`[TRENDii] product page load fired.`);

      trendiiPixel.send({
        eventName: "PixelView",
        eventData: {
          id: product.id,
          title: product.title,
          sku: product.sku,
          price: product.price,
          currency: product.currency,
        },
      });
    };

    return { trackAddToCart, trackPageLoad };
  }, []);
